import axios from 'axios';
import { store } from '../store';

export class HttpController {
  static setupHttpClient(token) {
    axios.defaults.headers.common.Authorization = token;
    axios.interceptors.request.use((config) => {
      // Django rest put, patch and delete methods must end with '/'
      if (!config.removeTrailingSlash
        && (config.method === 'put' || config.method === 'delete' || config.method === 'get' || config.method === 'patch' || config.method === 'post')
        && config.url[config.url.length - 1] !== '/') {
        config.url += '/';
      }
      return config;
    });
    axios.interceptors.response.use(undefined, async (error) => {
      if (error.response && error.response.status === 401) {
        await store.dispatch('logout');
      } else {
        throw error;
      }
    });
  }

  static updateHttpClientLanguage(language) {
    axios.defaults.headers.common['Accept-Language'] = language;
  }

  static clearHttpClient() {
    delete axios.defaults.headers.common.Authorization;
  }
}
